import { DataProxy } from 'apollo-cache'
import {
  GetActivityFeedDocument,
  GetActivityFeedQuery,
  GetActivityFeedQueryVariables,
} from 'gqlTypes'
import produce from 'immer'
import { ErrorHandler } from 'modules/tracing'

export interface UpdateActivityFeedProps {
  client: DataProxy
  variables: GetActivityFeedQueryVariables
  update: (data: GetActivityFeedQuery['activityFeed']) => void
}
export const updateActivityFeed = ({
  client,
  variables,
  update,
}: UpdateActivityFeedProps) => {
  try {
    const activities = client.readQuery<
      GetActivityFeedQuery,
      GetActivityFeedQueryVariables
    >({
      query: GetActivityFeedDocument,
      variables,
    })

    // When a user goes directly to the inspector (by URL or remembering the
    // option via localStorage) activites are not loaded but revision
    // subscription is already listening, so this situation is expected
    if (!activities) {
      return
    }

    const newActivities = produce(activities, draft =>
      update(draft.activityFeed)
    )

    client.writeQuery({
      data: newActivities,
      query: GetActivityFeedDocument,
      variables,
    })
  } catch (err) {
    ErrorHandler.ignore(
      err,
      'there is nothing to update if readQuery or writeQuery throws an error'
    )
  }
}
